import {
    SpecialMatchListActions,
    SpecialMatchListSetLoadingData,
    SpecialMatchListStoreModel,
} from './special-match-list.constants';
import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction } from '@om-fe/store';
import { filterItemsFromRecords } from '../../utils/filter-items-from-records';
import applyUpdatesForMatchList from '../../utils/apply-updates-for-match-list';
import { getSpecialMatchListSliceName } from './special-match-list.utils';
import { AggregatorOneOfTypeModel } from '@om-fe/models';
import { UpdateAction } from '@om-fe/api';
import { isBrowser } from '@om-fe/utils';

const initialState: SpecialMatchListStoreModel = {
    fetchedFromBrowser: isBrowser(),
    ready: false,
    totalRecords: 0,
    limit: 0,
    isLoadingMoreData: false,
    isLoadingData: true,
    discipline: undefined,
    filteredEventInfos: {},
    filteredMainMarketsList: [],
    filteredMainMarkets: {},
    filteredMarketGroupsOverviewList: [],
    filteredMarketGroupsOverview: {},
    filteredEventStatistics: [],
    filteredMarketAndOutcomeRelation: {},
    filteredOutcomes: {},
    filteredBettingOffers: {},
    filteredMatchesWithEvents: {},
    filteredMatchesIds: [],
    filteredStreamingProviderEventRelation: {},
    marketsWithOutcomesAndBettingOffers: {},
    filteredMainOutrightsMarketsList: [],
};

export const specialMatchListReducerCreator = (instanceId: string) => (
    state: SpecialMatchListStoreModel = initialState,
    action: AppAction,
): SpecialMatchListStoreModel => {
    const slice: string = getSpecialMatchListSliceName(instanceId);

    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {

        case SpecialMatchListActions.SetLoadingData: {
            const { payload: { isLoadingMoreData } } = action as SpecialMatchListSetLoadingData;

            return {
                ...state,
                isLoadingData: !isLoadingMoreData,
                isLoadingMoreData,
            };
        }

        case SpecialMatchListActions.SetFilterData: {
            
            return {
                ...state,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;
            const records: AggregatorOneOfTypeModel[] = payload.records;

            return {
                ...state,
                ...filterItemsFromRecords(records, true),
                fetchedFromBrowser: isBrowser(),
                totalRecords: 25,
                limit: 25,
                ready: true,
                isLoadingData: false,
                isLoadingMoreData: false,
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
                totalRecords: 25,
                limit: 25,
                isLoadingMoreData: false,
            };
        }
        default:
            return state;
    }
};